import { Button } from '@lokalise/louis';

import styled, { css } from '@app/styled';
import { color, modifier, radius, spacing, transition } from '@app/theme';

const colorOrange = '#FF6336';

export const ContentWrapper = styled.div`
    display: flex;
    gap: ${spacing(4)};
    flex-direction: row;
    flex-wrap: nowrap;
    padding-top: ${spacing(6)};
`;

export const CtaButton = styled(Button)`
    background-color: ${colorOrange};
    border-color: ${colorOrange};
    color: ${color(`custom.content.white`)};

    &:hover:not([disabled]):not([aria-expanded='true']) {
        background-color: ${colorOrange};
        border-color: ${colorOrange};
    }
`;

export const ReviewList = styled.ol`
    padding-left: ${spacing(3)};
`;

export const ListItem = styled.li<{ $isHighlighted: boolean }>`
    color: ${color('custom.content.secondary')};
    transition: color ${transition('default')} ease-in-out;

    ${modifier(
        '$isHighlighted',
        css`
            color: ${color('custom.content.primary')};
        `,
    )}
`;

export const FeedbackWrapper = styled.div`
    position: relative;
`;

export const FeedbackContent = styled.div`
    position: absolute;
    top: ${spacing(8)};
    left: -${spacing(6)};
    right: -${spacing(6)};
    padding: ${spacing(4)} ${spacing(6)};
    background-color: ${color('custom.background.primary')};
    border-radius: ${radius('m')};
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
